import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useAddAndRemoveTag = (post, profileId, refetchTags) => {
    const [loading, setLoading] = useState(false);

    const insertTag = useCallback(
        async (event, searchText, setSearchText) => {
            const isButton = !event;
            const isFormSubmit = event && event.type === "submit";
            const isEnter = event && event.key === "Enter";

            if ((isButton || isFormSubmit || isEnter) && searchText.trim() !== "") {
                if (event && event.preventDefault) event.preventDefault();

                if (searchText.trim().length > 150) {
                    toast.error("Tag name can be at most 150 characters.");
                    return;
                }

                setSearchText("");

                const requestObj = {
                    fn: "tagInsert",
                    profilId: profileId,
                    tagName: searchText.trim(),
                };

                setLoading(true);

                post(requestObj)
                    .then(() => {
                        toast.success("Tag successfully added!");
                        //refetchProfile();
                        refetchTags();
                    })
                    .catch((err) => {
                        toast.error(apiErrorText(err));
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        },
        [post, profileId, refetchTags]
    );
    const removeTag = useCallback(
        async (tagId, tagName) => {
            const requestObj = {
                fn: "tagDelete",
                profilId: profileId,
                tagName: tagName,
            };
            try {
                setLoading(true);
                const response = await post(requestObj);
                if (response.status === 200) {
                    toast.success("Tag successfully removed!");
                    //refetchProfile();
                    refetchTags();
                }
            } catch (error) {
                toast.error(apiErrorText(error));
            } finally {
                setLoading(false);
            }
        },
        [post, profileId, refetchTags]
    );

    return { insertTag, removeTag, loading };
};

export default useAddAndRemoveTag;
